import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Renouvellement } from '@models/domains/renewal';
import { ValidationDetail } from '@models/shared';
import { FileAttachment } from '@models/shared';
import { IdObject, DemandeRenouvellementPost } from '@models/api/requests';

@Injectable({
  providedIn: 'root'
})
export class DemandeRenouvellementService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private readonly http: HttpClient) {}

  getAllDemandesRenouvellement() {
    return this.http.get<any>(this.module + '/demandes-renouvellement');
  }

  createDemandesRenouvellement(demandeRenouvellement: DemandeRenouvellementPost, piecesJointes: File[]): Observable<any> {
    const formdata = new FormData();
    formdata.append('demandeRenouvellement', JSON.stringify(demandeRenouvellement));
    piecesJointes.forEach((file, index) => {
      formdata.append(`piecesJointes`, file);
    });
    return this.http.post<any>(this.module + '/demandes-renouvellement', formdata);
  }

  updateDemandesRenouvellement(demandeRenouvellement: DemandeRenouvellementPost, id: string): Observable<any> {
    return this.http.put<any>(`${this.module}/demandes-renouvellement/${id}`, demandeRenouvellement);
  }

  getDemandesRenouvellementById(id: string): Observable<Renouvellement> {
    return this.http.get<Renouvellement>(`${this.module}/demandes-renouvellement/${id}`);
  }

  getDetailsValidations(id: string, typeDemande: string): Observable<ValidationDetail[]> {
    return this.http.get<ValidationDetail[]>(`${this.module}/demandes/${id}/details-validations/${typeDemande}`);
  }

  deleteDemandesRenouvellement(id: string) {
    return this.http.delete(`${this.module}/demandes-renouvellement/${id}`);
  }

  getPj(id: string): Observable<FileAttachment[]> {
    return this.http.get<FileAttachment[]>(`${this.module}/demandes-renouvellement/pieces-jointes/${id}`);
  }

  postPj(id: string, piecesJointes: File[]): Observable<FileAttachment[]> {
    const formdata = new FormData();
    piecesJointes.forEach((file) => {
      formdata.append(`pieceJointe`, file);
    });
    return this.http.post<any>(`${this.module}/demandes-renouvellement/pieces-jointes/${id}`, formdata);
  }

  deletePj(id: string, idPj: string): Observable<FileAttachment[]> {
    return this.http.delete<FileAttachment[]>(`${this.module}/demandes-renouvellement/pieces-jointes/${id}/${idPj}`);
  }
}
